class DragAreaDirective {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
    }

    get scope() {
        return {
            dragOver: '=?',
        };
    }

    link(scope, element, attrs, ngModel) {
        element.bind('dragstart', (event) => {
            // workaround: must call setData on Firefox, otherwise drag won't work
            event.dataTransfer.setData('text', 'drag-me');
            event.dataTransfer.effectAllowed = 'copyMove';
        });
        element.bind('dragenter dragover', (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.dataTransfer.dropEffect = 'copy';
            scope.dragOver = true;
        });
        element.bind('dragleave', (event) => {
            event.preventDefault();
            event.stopPropagation();
            scope.dragOver = false;
        });
        element.bind('drop', (event) => {
            event.preventDefault();
            event.stopPropagation();
            ngModel.$setViewValue(event.dataTransfer.files[0], 'drop');
            ngModel.$render();
            ngModel.$setDirty();
            ngModel.$setTouched();
        });
    }

    static factory() {
        return new DragAreaDirective();
    }
}

// Explicit DI annotation for factory used in angular.directive registration
DragAreaDirective.factory.$inject = [];

export default DragAreaDirective.factory;
